import React from 'react'

const Activity = props => {
  return (
    <div>Activity</div>
  )
}

export default Activity